module.exports = __webpack_public_path__ + "mt.4f20d5a79880bb85d373.svg";


//////////////////
// WEBPACK FOOTER
// /var/www/portal/bullseye/node_modules/flag-icon-css/flags/1x1/mt.svg
// module id = ../../../../flag-icon-css/flags/1x1/mt.svg
// module chunks = styles